import { ActionListItem, Text } from "@certn/cascadia";
import { Icon, Radio } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import {
  doesCardHaveIcon,
  getPaymentIcon,
} from "../../../pages/payment-profiles/helpers";
import { Schemas } from "../../../types";

interface Props {
  profile: Schemas["CustomerGroupBillingProfileCustomerAccountPaymentprofileSet"];
}

export function PaymentCard(props: Props) {
  const { profile } = props;
  const { t } = useTranslation();

  return (
    <Radio
      className={styles.radio}
      testID={profile.id}
      key={profile.id}
      value={profile.id}
    >
      <ActionListItem
        className={styles.actionListItem}
        title={profile.title}
        leading={
          profile.brand && doesCardHaveIcon(profile.brand) ? (
            <img
              src={profile.brand ? getPaymentIcon(profile.brand) : ""}
              alt={profile.brand || undefined}
              width="var(--space-6)"
              height="var(--space-6)"
            />
          ) : (
            <Icon name="credit_card" size="space-6" />
          )
        }
      >
        <Text style="global/body-secondary">
          {t("Card ending in •••• {{number}}", {
            number: profile.number,
          })}
        </Text>
      </ActionListItem>
    </Radio>
  );
}

const styles = {
  radio: css({
    paddingLeft: "var(--space-4) !important",
    paddingRight: "var(--space-4) !important",
    paddingTop: "var(--space-4) !important",
    paddingBottom: "var(--space-4) !important",
    flexDirection: "row",
    justifyContent: "flex-start",
  }),
  actionListItem: css({
    "&": {
      alignItems: "flex-start",
      paddingTop: "var(--space-0)",
      paddingBottom: "var(--space-0)",
    },
  }),
};
